import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconHandStop,
  IconFilter,
  IconSearch,
  IconDownload,
  IconCalendar,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Input,
  Menu,
  rem,
  Select,
  Tooltip,
} from "@mantine/core";
import ProcessInstancesModel from "../../model/ProcessInstancesModel";
import { DatePickerInput } from "@mantine/dates";
import { getProcessDefSelect, getUsersSelect } from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { pageTable } from "../../_base/_const/_constVar";
const SystemTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<ProcessInstancesModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //
  const dataMethod = [
    { value: "POST", label: "Tạo mới" },
    { value: "PUT", label: "Chỉnh sửa" },
    { value: "GET", label: "Đọc thông tin" },
    { value: "DELETE", label: "Xóa" },
  ];
  const dataStatus = [
    { value: "200", label: "Thành công" },
    { value: "500", label: "Xử lý lỗi" },
  ];
  const [dateUsers, setUsers] = useState<SelectListItem[]>([]);

  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);

  useEffect(() => {
    getUser();
  }, []);

  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setUsers(data);
  }

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  const [keySearch, setKeySearch] = useState<string>("");
  const [createdById, setcreatedById] = useState<number>(0);
  const [status, setStatus] = useState<string>("");
  const [method, setMethod] = useState<string>("");

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setOpenedMenu(false);
    const url = new URL("/api/v1/history/logs", "https://localhost:7118");
    url.searchParams.set("page", `${pagination.pageIndex}`);
    url.searchParams.set("pageSize", `${pagination.pageSize}`);
    if (keySearch && keySearch.length > 0)
      url.searchParams.set("key", `${keySearch}`);
    if (createdById && createdById > 0)
      url.searchParams.set("createdById", `${createdById}`);
    if (status && status.length > 0)
      url.searchParams.set("status", `${status.trim()}`);
    if (method && method.length > 0)
        url.searchParams.set("method", `${method.trim()}`);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id + "|" + _q.desc;
    }
    url.searchParams.set("soft", `${_softing}`);
    try {
      const response = await fetch(url.href);
      const json = (await response.json()) as MessageResponse<any>;
      setData(json.data.data);
      setRowCount(json.data.count);
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  function progessTemplate(props: any): any {
    return (
      <>
        <Tooltip label="Xem thông tin">
          <ActionIcon variant="light" aria-label="Settings" color="blue">
            <IconSearch size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Lịch sử công việc">
          <ActionIcon variant="light" aria-label="Settings" color="cyan">
            <IconHistory size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  function getColorStatus(text: string) {
    switch (text.trim()) {
      case "Phê duyệt":
        return "teal";
      case "Từ chối":
        return "red";
    }
  }

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorStatus(renderedCellValue?.toString() ?? "")}>
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "method",
        header: "Phương thức",
        size: 30,
      },
      {
        accessorKey: "url",
        header: "Đối tượng",
        size: 50,
      },
      {
        accessorKey: "ip",
        header: "IP",
        size: 50,
      },
      {
        accessorKey: "date",
        header: "Ngày thao tác",
      },

      {
        accessorKey: "user",
        header: "Người thao tác",
      },
    ],
    []
  );
  const [openedMenu, setOpenedMenu] = useState(true);
  React.useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection });
  }, [rowSelection]);
  
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (230 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);
  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Input
            placeholder="Nhập từ khóa"
            onChange={(e) => {
              setKeySearch(e.target.value ?? "");
            }}
          />

          <Menu
            shadow="md"
            trigger="hover"
            openDelay={100}
            closeDelay={200}
            opened={openedMenu}
            withArrow
            // onChange={(e)=>{
            //     setOpened111(true)
            // }}
          >
            <Menu.Target>
              <Button
                rightSection={<IconFilter size={14} />}
                color="teal"
                variant="outline"
                onClick={(e) => {
                  setOpenedMenu(!openedMenu);
                }}
              >
                Bộ lọc
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <>
                <div style={{ padding: "10px", minWidth: "300px" }}>
                  <Select
                    id="createBy"
                    label="Người thao tác"
                    placeholder="Chọn"
                    data={dateUsers?.map((item: SelectListItem) => {
                      return {
                        value: item.value,
                        label: item.text,
                      };
                    })}
                    value={createdById.toString()}
                    onChange={(e) => {
                      const value = parseFloat(e ?? ""); // Convert giá trị nhập thành số
                      if (!isNaN(value) && e) {
                        setcreatedById(parseFloat(e));
                      } else {
                        setcreatedById(0);
                      }
                    }}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                  />
                  <Select
                    id="status"
                    label="Hành động"
                    placeholder="Chọn"
                    data={dataStatus}
                    nothingFoundMessage="Không có dữ liệu"
                    value={status}
                    onChange={(e) => {
                      setStatus(e ?? "");
                    }}
                    searchable
                    clearable
                  />

                  <Select
                    id="method"
                    label="Loại request"
                    placeholder="Chọn"
                    data={dataMethod}
                    nothingFoundMessage="Không có dữ liệu"
                    value={method}
                    onChange={(e) => {
                      setMethod(e ?? "");
                    }}
                    searchable
                    clearable
                  />
                </div>
              </>
            </Menu.Dropdown>
          </Menu>
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
          >
            Tìm kiếm
          </Button>
        </Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,

      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "bold", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    mantineTableProps: {
      striped: true,
    },
  });

  //#endregion
  return (
    <>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default SystemTable;
